import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MatSnackBar,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatPaginator,
} from "@angular/material";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ClipBoardService } from "src/app/services/clipboard.service";
import { ServerService } from "src/app/services/server.service";
import { AddAmountSpentComponent } from "../../campaign-dir/add-amount-spent/add-amount-spent.component";
import { AddBudgetComponent } from "../../campaign-dir/add-budget/add-budget.component";
import { AddFeedbackComponent } from "../../campaign-dir/add-feedback/add-feedback.component";
import { AddLeadDeliveredComponent } from "../../campaign-dir/add-lead-delivered/add-lead-delivered.component";
import { AmountSpentListComponent } from "../../campaign-dir/amount-spent-list/amount-spent-list.component";
import { BudgetListComponent } from "../../campaign-dir/budget-list/budget-list.component";
import { CampaignFilterModalComponent } from "../../campaign-dir/campaign-filter-modal/campaign-filter-modal.component";
import { EscalationStatusModalComponent } from "../../campaign-dir/escalation-status-modal/escalation-status-modal.component";
import { FeedbackListModalComponent } from "../../campaign-dir/feedback-list-modal/feedback-list-modal.component";
import { LeadDeliveryListComponent } from "../../campaign-dir/lead-delivery-list/lead-delivery-list.component";
import { RaiseEscalationComponent } from "../../campaign-dir/raise-escalation/raise-escalation.component";
import { SaleCampaignClientCreateModalComponent } from "../../campaign-dir/sale-campaign-client-create-modal/sale-campaign-client-create-modal.component";
import { SaleCampaignProjectCreateModalComponent } from "../../campaign-dir/sale-campaign-project-create-modal/sale-campaign-project-create-modal.component";
import { AssignUserToJobsComponent } from "../../campaign/assign-user-to-jobs/assign-user-to-jobs.component";
import { CampaignJobAttachmentsComponent } from "../../campaign/campaign-job-attachments/campaign-job-attachments.component";
import { CampaignJobLinksComponent } from "../../campaign/campaign-job-links/campaign-job-links.component";
import { CampaignStatusComponent } from "../../campaign/campaign-status/campaign-status.component";
import { CreativeMasterCommentModalComponent } from "../../creative-master/creative-master-comment-modal/creative-master-comment-modal.component";
import { CreativeMasterFilterModalComponent } from "../../creative-master/creative-master-filter-modal/creative-master-filter-modal.component";
import { AscalationCommentModalComponent } from "../../escalation/ascalation-comment-modal/ascalation-comment-modal.component";
import { PresalesDoneStatusComponent } from "../../campaign/presales-done-status/presales-done-status.component";
import { PresaleCommentModalComponent } from "../presale-comment-modal/presale-comment-modal.component";
import { PresaleMasterFilterComponent } from "../presale-master-filter/presale-master-filter.component";
import { CancelledStatusModalComponent } from "../../campaign/cancelled-status-modal/cancelled-status-modal.component";
import { ListingPresalesProgressLogComponent } from "../../campaign/listing-presales-progress-log/listing-presales-progress-log.component";
import { CreatePresalesProgressLogComponent } from "../../campaign/create-presales-progress-log/create-presales-progress-log.component";
import * as saveAs from "file-saver";
@Component({
  selector: "app-presale-job-list",
  templateUrl: "./presale-job-list.component.html",
  styleUrls: ["./presale-job-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PresaleJobListComponent implements OnInit {
  authToken: any = localStorage.getItem("token");
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"));
  showComponentLoader: boolean = false;

  project: any = {
    campaigns: [],
    pagination: {},
  };

  elasticSearch: any = "";
  statusSpinner: boolean = false;

  saleCampaignProjectCreateModalComponent: MatDialogRef<SaleCampaignProjectCreateModalComponent>;

  saleCampaignClientCreateModalComponent: MatDialogRef<SaleCampaignClientCreateModalComponent>;
  campaignFilterModalComponent: MatDialogRef<CampaignFilterModalComponent>;
  campaignStatusComponent: MatDialogRef<CampaignStatusComponent>;

  addLeadDeliveredComponent: MatDialogRef<AddLeadDeliveredComponent>;
  leadDeliveryListComponent: MatDialogRef<LeadDeliveryListComponent>;

  addBudgetComponent: MatDialogRef<AddBudgetComponent>;
  amountSpentListComponent: MatDialogRef<AmountSpentListComponent>;

  addAmountSpentComponent: MatDialogRef<AddAmountSpentComponent>;
  budgetListComponent: MatDialogRef<BudgetListComponent>;

  addFeedbackComponent: MatDialogRef<AddFeedbackComponent>;
  feedbackListModalComponent: MatDialogRef<FeedbackListModalComponent>;

  raiseEscalationComponent: MatDialogRef<RaiseEscalationComponent>;
  escalationStatusModalComponent: MatDialogRef<EscalationStatusModalComponent>;

  creativeMasterFilterModalComponent: MatDialogRef<CreativeMasterFilterModalComponent>;

  ascalationCommentModalComponent: MatDialogRef<AscalationCommentModalComponent>;

  assignUserToJobsComponent: MatDialogRef<AssignUserToJobsComponent>;

  campaignJobAttachmentsComponent: MatDialogRef<CampaignJobAttachmentsComponent>;

  campaignJobLinksComponent: MatDialogRef<CampaignJobLinksComponent>;

  creativeMasterCommentModalComponent: MatDialogRef<CreativeMasterCommentModalComponent>;

  presalesDoneStatusComponent: MatDialogRef<PresalesDoneStatusComponent>;

  presaleCommentModalComponent: MatDialogRef<PresaleCommentModalComponent>;

  presaleMasterFilterComponent: MatDialogRef<PresaleMasterFilterComponent>;

  cancelledStatusModalComponent: MatDialogRef<CancelledStatusModalComponent>;

  listingPresalesProgressLogComponent: MatDialogRef<ListingPresalesProgressLogComponent>;

  createPresalesProgressLogComponent: MatDialogRef<CreatePresalesProgressLogComponent>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  pageIndex: number = 0;
  pageSize: number = 100;

  lenCount: any = 0;

  url = "";

  createdAt: any;
  completedAt: any;
  selectedCampaign: any;
  selectedcallingReason: any;
  selectedCallingType: any;
  selectedTeamLead: any;
  selectedTargetType: any;
  selectedAssignedTo: any;
  selectedStatus: any;
  selectedPriority: any;
  selectedCreatedBy: any;

  escalationStatusList: any;
  creativeStatusList: any;
  presaleStatusList: any;
  presalesCallingReasonList: any;
  presalesCallingTypeList: any;
  presalesTargetTypeList: any;
  priorityList: any;
  teamLeadList: any;
  createdByList: any;
  assignedUserList: any;
  campaignList: any;

  myDateRangePickerOptions = {
    dateFormat: "dd.mm.yyyy",
  };

  allIsActive: boolean = true;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private titleService: Title,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar
  ) {
    // sessionStorage.clear();
    this.showComponentLoader = true;
    this.titleService.setTitle("AutomateLeads - Projects");
  }

  ngOnInit() {
    this.allPreSaleJobMaster();
    this.getCommon();
    this.getCreatedBy();
    this.getAssignUser();
    this.getTeamLead();
    this.getCampaignForFilter();
  }
  exportDetails() {
    this.statusSpinner = true;
    let body = { export: true };

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch;
    }

    if (
      this.createdAt != undefined &&
      this.createdAt != "" &&
      this.createdAt != null
    ) {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (this.completedAt != undefined && this.completedAt != "") {
      body["completed_at"] = [
        this.completedAt.formatted.split(" - ")[0],
        this.completedAt.formatted.split(" - ")[1],
      ];
    }

    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body["campaign_id"] = this.selectedCampaign;
    }

    if (
      this.selectedcallingReason != undefined &&
      this.selectedcallingReason != ""
    ) {
      body["calling_reason"] = this.selectedcallingReason;
    }

    if (
      this.selectedCallingType != undefined &&
      this.selectedCallingType != ""
    ) {
      body["calling_type"] = this.selectedCallingType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedTeamLead != undefined && this.selectedTeamLead != "") {
      body["tl_id"] = this.selectedTeamLead;
    }

    if (this.selectedTargetType != undefined && this.selectedTargetType != "") {
      body["target_type"] = this.selectedTargetType;
    }

    if (this.selectedAssignedTo != undefined && this.selectedAssignedTo != "") {
      body["assigned_to_id"] = this.selectedAssignedTo;
    }

    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority;
    }

    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body["created_by_id"] = this.selectedCreatedBy;
    }

    let url = "campaign_module/pre_sales_jobs/master_list";

    this.serverService
      .exportCampaignDetails(url, body, this.authToken)
      .subscribe(
        (data) => {
          //saveAs(new Blob([data.body], { type: 'application/xlsx' }), 'campaign_drr_report' + '.xlsx')
          // saveAs(new Blob([data.body], { type: 'text/csv' }), 'campaign_drr_report' + '.csv')
          const contentDisposition = data.headers.get("content-disposition");
          const contentType = data.headers.get("content-type");
          const regex = /filename="([^"]+)"/;
          const match = contentDisposition.match(regex);
          saveAs(new Blob([data.body], { type: contentType }), match[1]);
          this.statusSpinner = false;
        },
        (err: any) => {
          console.error("Error exporting DRR:", err);
          this.statusSpinner = false;
        }
      );
  }
  allPreSaleJobMaster(isFilter?: any) {
    //console.log(this.myDateRangePickerOptions)

    if (isFilter == "filter") {
      this.allIsActive = false;
    }

    let body = {};

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch;
    }

    if (
      this.createdAt != undefined &&
      this.createdAt != "" &&
      this.createdAt != null
    ) {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (this.completedAt != undefined && this.completedAt != "") {
      body["completed_at"] = [
        this.completedAt.formatted.split(" - ")[0],
        this.completedAt.formatted.split(" - ")[1],
      ];
    }

    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body["campaign_id"] = this.selectedCampaign;
    }

    if (
      this.selectedcallingReason != undefined &&
      this.selectedcallingReason != ""
    ) {
      body["calling_reason"] = this.selectedcallingReason;
    }

    if (
      this.selectedCallingType != undefined &&
      this.selectedCallingType != ""
    ) {
      body["calling_type"] = this.selectedCallingType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedTeamLead != undefined && this.selectedTeamLead != "") {
      body["tl_id"] = this.selectedTeamLead;
    }

    if (this.selectedTargetType != undefined && this.selectedTargetType != "") {
      body["target_type"] = this.selectedTargetType;
    }

    if (this.selectedAssignedTo != undefined && this.selectedAssignedTo != "") {
      body["assigned_to_id"] = this.selectedAssignedTo;
    }

    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority;
    }

    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body["created_by_id"] = this.selectedCreatedBy;
    }

    //console.log(body)

    this.pageIndex = 0;
    this.pageSize = 50;

    this.showComponentLoader = true;

    this.url =
      "campaign_module/pre_sales_jobs/master_list?per_page=" +
      this.pageSize +
      "&page=" +
      this.pageIndex;

    this.serverService
      .campaignListByFilter(this.url, body, this.authToken)
      .subscribe(
        (data) => {
          this.project = data;
          //console.log(this.project)
          //this.lenCount = data.pre_sales_jobs.length
          //console.log(this.lenCount)
          this.showComponentLoader = false;
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  getNext(event) {
    this.showComponentLoader = true;

    let body1 = {
      per_page: event.pageSize,
      page: event.pageIndex,
    };

    let body = {};

    this.pageSize = body1.per_page;
    this.pageIndex = body1.page;
    let indexPage = this.pageIndex + 1;

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch;
    }

    if (
      this.createdAt != undefined &&
      this.createdAt != "" &&
      this.createdAt != null
    ) {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (this.completedAt != undefined && this.completedAt != "") {
      body["completed_at"] = [
        this.completedAt.formatted.split(" - ")[0],
        this.completedAt.formatted.split(" - ")[1],
      ];
    }

    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body["campaign_id"] = this.selectedCampaign;
    }

    if (
      this.selectedcallingReason != undefined &&
      this.selectedcallingReason != ""
    ) {
      body["calling_reason"] = this.selectedcallingReason;
    }

    if (
      this.selectedCallingType != undefined &&
      this.selectedCallingType != ""
    ) {
      body["calling_type"] = this.selectedCallingType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedTeamLead != undefined && this.selectedTeamLead != "") {
      body["tl_id"] = this.selectedTeamLead;
    }

    if (this.selectedTargetType != undefined && this.selectedTargetType != "") {
      body["target_type"] = this.selectedTargetType;
    }

    if (this.selectedAssignedTo != undefined && this.selectedAssignedTo != "") {
      body["assigned_to_id"] = this.selectedAssignedTo;
    }

    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority;
    }

    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body["created_by_id"] = this.selectedCreatedBy;
    }

    this.url =
      "campaign_module/pre_sales_jobs/master_list?per_page=" +
      this.pageSize +
      "&page=" +
      indexPage;

    this.serverService
      .campaignListByFilter(this.url, body, this.authToken)
      .subscribe(
        (data) => {
          this.project = data;
          this.showComponentLoader = false;
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  filter(campaignStatus?: any) {
    let body = {};

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (this.completedAt != undefined && this.completedAt != "") {
      body["completed_at"] = [
        this.completedAt.formatted.split(" - ")[0],
        this.completedAt.formatted.split(" - ")[1],
      ];
    }

    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body["campaign_id"] = this.selectedCampaign;
    }

    if (
      this.selectedcallingReason != undefined &&
      this.selectedcallingReason != ""
    ) {
      body["calling_reason"] = this.selectedcallingReason;
    }

    if (
      this.selectedCallingType != undefined &&
      this.selectedCallingType != ""
    ) {
      body["calling_type"] = this.selectedCallingType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedTeamLead != undefined && this.selectedTeamLead != "") {
      body["tl_id"] = this.selectedTeamLead;
    }

    if (this.selectedTargetType != undefined && this.selectedTargetType != "") {
      body["target_type"] = this.selectedTargetType;
    }

    if (this.selectedAssignedTo != undefined && this.selectedAssignedTo != "") {
      body["assigned_to_id"] = this.selectedAssignedTo;
    }

    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority;
    }

    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body["created_by_id"] = this.selectedCreatedBy;
    }

    //console.log(body)

    this.presaleMasterFilterComponent = this.dialog.open(
      PresaleMasterFilterComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        panelClass: "cdk-overlay-panel-right-side",
        data: body,
      }
    );
    this.presaleMasterFilterComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        // console.log(result)

        this.showComponentLoader = true;

        if (result.created_at != undefined && result.created_at != "") {
          this.createdAt = result.created_at;
        } else {
          this.createdAt = "";
        }

        if (result.completed_at != undefined && result.completed_at != "") {
          this.completedAt = result.completed_at;
        } else {
          this.completedAt = "";
        }

        if (result.campaign_id != undefined && result.campaign_id != "") {
          this.selectedCampaign = result.campaign_id;
        } else {
          this.selectedCampaign = "";
        }

        if (result.calling_reason != undefined && result.calling_reason != "") {
          this.selectedcallingReason = result.calling_reason;
        } else {
          this.selectedcallingReason = "";
        }

        if (result.calling_type != undefined && result.calling_type != "") {
          this.selectedCallingType = result.calling_type;
        } else {
          this.selectedCallingType = "";
        }

        if (result.status != undefined && result.status != "") {
          this.selectedStatus = result.status;
        } else {
          this.selectedStatus = "";
        }

        if (result.v != undefined && result.tl_id != "") {
          this.selectedTeamLead = result.tl_id;
        } else {
          this.selectedTeamLead = "";
        }

        if (result.target_type != undefined && result.target_type != "") {
          this.selectedTargetType = result.target_type;
        } else {
          this.selectedTargetType = "";
        }

        if (result.assigned_to_id != undefined && result.assigned_to_id != "") {
          this.selectedAssignedTo = result.assigned_to_id;
        } else {
          this.selectedAssignedTo = "";
        }

        if (result.priority != undefined && result.priority != "") {
          this.selectedPriority = result.priority;
        } else {
          this.selectedPriority = "";
        }

        if (result.created_by_id != undefined && result.created_by_id != "") {
          this.selectedCreatedBy = result.created_by_id;
        } else {
          this.selectedCreatedBy = "";
        }

        this.allPreSaleJobMaster();
      }
    });
  }

  selectCreatedDate(event: any) {
    if (
      event.formatted != undefined &&
      event.formatted != "" &&
      event.formatted != null
    ) {
      this.createdAt = event;
      this.allPreSaleJobMaster("filter");
    } else {
      this.createdAt = undefined;
      this.allPreSaleJobMaster("filter");
    }
  }

  selectComplatedDate(event: any) {
    if (
      event.formatted != undefined &&
      event.formatted != "" &&
      event.formatted != null
    ) {
      this.completedAt = event;
      this.allPreSaleJobMaster("filter");
    } else {
      this.completedAt = undefined;
      this.allPreSaleJobMaster("filter");
    }
  }

  resetFilter() {
    this.createdAt = null;
    this.completedAt = null;
    this.selectedCampaign = null;
    this.selectedAssignedTo = null;
    this.selectedCreatedBy = null;
    this.selectedPriority = null;
    this.selectedStatus = null;
    this.selectedcallingReason = null;
    this.selectedCallingType = null;
    this.selectedTeamLead = null;
    this.selectedTargetType = null;
    this.allPreSaleJobMaster();
    this.allIsActive = true;
  }

  getAssignUser() {
    this.showComponentLoader = true;

    let url = "/campaign_module/user_list";
    this.serverService.getMM(url, this.authToken).subscribe(
      (data) => {
        this.assignedUserList = data.data;
        this.assignedUserList.unshift({ id: null, name: "Assigned To" });
        //console.log(this.mmList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  getCreatedBy() {
    this.showComponentLoader = true;

    let url = "/campaign_module/user_list";
    this.serverService.getSalePerson(url, this.authToken).subscribe(
      (data) => {
        this.createdByList = data.data;
        this.createdByList.unshift({ id: null, name: "Created By" });
        //console.log(this.salePersonList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  getTeamLead() {
    this.showComponentLoader = true;

    this.serverService.getTeamLeader(this.authToken).subscribe(
      (data) => {
        this.teamLeadList = data.data;
        this.teamLeadList.unshift({ id: null, name: "Team Lead" });
        //console.log(this.salePersonList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  getCampaignForFilter() {
    this.showComponentLoader = true;

    this.serverService
      .getCampaignForFilter("campaign_module/campaign/list", this.authToken)
      .subscribe(
        (data) => {
          this.campaignList = data;
          this.campaignList.unshift({ id: null, name: "Campaign" });
          //console.log(this.campaignList)
          this.showComponentLoader = false;
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  openProjectCreateModal(project: any) {
    this.saleCampaignProjectCreateModalComponent = this.dialog.open(
      SaleCampaignProjectCreateModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "50vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.saleCampaignProjectCreateModalComponent
      .afterClosed()
      .subscribe((result) => {
        if (result != undefined) {
          this.showComponentLoader = true;
          this.allPreSaleJobMaster();
        }
      });
  }

  removeSearch() {
    this.elasticSearch = "";
    this.allPreSaleJobMaster();
  }

  openClientCreateModal(project) {
    this.saleCampaignClientCreateModalComponent = this.dialog.open(
      SaleCampaignClientCreateModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.saleCampaignClientCreateModalComponent
      .afterClosed()
      .subscribe((result) => {
        if (result != undefined) {
          this.showComponentLoader = true;
          this.allPreSaleJobMaster();
        }
      });
  }

  updateCampaignStatus(data: any, status) {
    let body = {
      status: status,
      // 'delivery_manager_id': this.project.spAm,
      // 'marketing_manager_id': this.project.spAm,
      // 'client_type': this.project.clientType,
      // 'client_name': this.project.clientName,
      // 'client_number': this.project.clientEmail,
      // 'city': this.project.city,
      // 'client_rera': this.project.clientRera,
      // 'project_name': this.project.projectName,
      // 'project_type': this.project.projectType,
      // 'project_address': this.project.location,
      // 'latitude': this.project.latitude,
      // 'longitude': this.project.longitude,
      // 'min_price': this.project.price,
      // 'project_configuration': this.project.configuration,
      // 'project_status': this.project.projectStatus,
      // 'possession': this.project.possession,
      // 'rera_number': this.project.reraId,
      // 'campaign_type': this.project.campaignType,
      // 'duration': this.project.duration,
      // 'no_of_leads': this.project.noOfLeads,
      // 'mode_of_delivery': this.project,
      // 'mode_of_notification': this.project,
      // 'offers': this.project,
      // 'media_plan': this.project,
    };

    this.showComponentLoader = true;
    this.serverService
      .editSaleCampaign(data.id, body, this.authToken)
      .subscribe(
        (data) => {
          // console.log(data);
          this.showComponentLoader = false;
          this.clipBoardService.showMessgeInText(
            "Campaign Update Successfully",
            "success-snackbar"
          );
          this.allPreSaleJobMaster();
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  goToDetail(data: any) {
    // this.router.navigate([,'_blank'])
    this.router.navigate([]).then((result) => {
      window.open("page/campaign-details/" + data.id, "_blank");
    });
  }

  confirmCampaignStatus(campaignId: any, status: any) {
    let statusesandCampaignId = {
      campaignId: campaignId,
      status: status,
    };

    this.campaignStatusComponent = this.dialog.open(CampaignStatusComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      data: statusesandCampaignId,
    });
    this.campaignStatusComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.allPreSaleJobMaster();
      }
    });
  }

  openLeadDeliveryModal(project) {
    this.addLeadDeliveredComponent = this.dialog.open(
      AddLeadDeliveredComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "900px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.addLeadDeliveredComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openLeadDeliveryListModal(project) {
    this.leadDeliveryListComponent = this.dialog.open(
      LeadDeliveryListComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "900px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.leadDeliveryListComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openAddAmountSpentModal(project) {
    this.addAmountSpentComponent = this.dialog.open(AddAmountSpentComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "900px",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.addAmountSpentComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openSpentListModal(project) {
    this.amountSpentListComponent = this.dialog.open(AmountSpentListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "900px",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.amountSpentListComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openAddBudgetModal(project) {
    this.addBudgetComponent = this.dialog.open(AddBudgetComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "1020px",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.addBudgetComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openAddBudgetListModal(project) {
    this.budgetListComponent = this.dialog.open(BudgetListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "1020px",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.budgetListComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openAddFeedbackModal(project) {
    this.addFeedbackComponent = this.dialog.open(AddFeedbackComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "80vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.addFeedbackComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openFeedbackListModal(project) {
    this.feedbackListModalComponent = this.dialog.open(
      FeedbackListModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1020px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.feedbackListModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openRaiseEscalationModal(project) {
    this.raiseEscalationComponent = this.dialog.open(RaiseEscalationComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "1020px",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.raiseEscalationComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  getCommon() {
    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details";

    this.serverService.getEscalationCategory(url, this.authToken).subscribe(
      (data) => {
        //console.log(data)
        this.escalationStatusList = data.escalation_status_list;
        this.presaleStatusList = data.presales_status_list;
        this.creativeStatusList = data.creative_status_list;
        this.presalesCallingReasonList = data.presales_calling_reason_list;
        this.presalesCallingTypeList = data.presales_calling_type_list;
        this.presalesTargetTypeList = data.presales_target_type_list;
        this.priorityList = data.priority_list;
        // this.campaignTypeList=data.creative_campaign_type_list;
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  getStyle(status: string) {
    switch (status) {
      case "Todo":
        return { "background-color": "#E3E3E3", color: "#454545" };
      case "In progress":
        return { "background-color": "#E3E3E3", color: "#454545" };
      case "Awaiting Update":
        return { "background-color": "#D0E0FF", color: "#102348" };
      case "On Hold":
        return { "background-color": "#E3E3E3", color: "#454545" };
      case "Done":
        return {
          "background-color": "rgba(87, 211, 87, 0.23)",
          color: "#008000",
        };
      case "Cancelled":
        return {
          "background-color": "#FFF7F6",
          color: "#8B2A1D",
          border: "0.5px solid #8B2A1D",
          cursor: "not-allowed!important",
        };
      default:
        return { "background-color": "#E3E3E3", color: "#454545" };
    }
  }
  getStatusStyle(row: any) {
    switch (row.status.toUpperCase()) {
      case "CANCELLED":
        return {
          cursor: "not-allowed",
          color: "#ACACAC",
          "text-decoration": "none",
        };

      default:
        return { cursor: "pointer", color: "#116BBD" };
    }
  }
  statusUpdate(rowData: any) {
    this.showComponentLoader = true;

    if (
      rowData.status == "Todo" ||
      rowData.status == "In progress" ||
      rowData.status == "Shared For Approval" ||
      rowData.status == "Awaiting Update" ||
      rowData.status == "On Hold"
    ) {
      let url = "/campaign_module/pre_sales_jobs/" + rowData.id;

      const formData: FormData = new FormData();
      formData.append("campaign_id", rowData.campaign_id);
      formData.append("status", rowData.status);

      this.serverService
        .EStatusUpdateForm(url, formData, this.authToken)
        .subscribe(
          (data) => {
            this.clipBoardService.showMessgeInText(
              "Presale Job Status Updated Successfully",
              "success-snackbar"
            );
            this.showComponentLoader = false;
          },
          (err) => {
            this.clipBoardService.checkServerError(err, this.authToken);
            this.showComponentLoader = false;
          }
        );
    }

    if (rowData.status == "Done") {
      //debugger
      this.preSalesDoneStatus(rowData);
    } else if (rowData.status.toUpperCase() == "CANCELLED") {
      this.showComponentLoader = false;
      this.cancelledStatusModal(rowData);
    }
  }
  cancelledStatusModal(element: any) {
    element["parent"] = "PreSalesJob";
    // project['file_type_job'] = file_type;
    // project['job_table_type'] = job_table_type
    this.cancelledStatusModalComponent = this.dialog.open(
      CancelledStatusModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "blue-snackbar",
        data: element,
      }
    );
    this.cancelledStatusModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = false;
        // this.allSaleCampaign()
        // this.getCampaignDetails();
        this.allPreSaleJobMaster();
        // this.timeLine();
      }
      this.allPreSaleJobMaster();
      this.showComponentLoader = false;
    });
  }
  preSalesDoneStatus(element) {
    // project['file_type_job'] = file_type;
    // project['job_table_type'] = job_table_type
    this.presalesDoneStatusComponent = this.dialog.open(
      PresalesDoneStatusComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "blue-snackbar",
        data: element,
      }
    );
    this.presalesDoneStatusComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;

        let url = "/campaign_module/pre_sales_jobs/" + element.id;

        const formData: FormData = new FormData();
        formData.append("campaign_id", element.campaign_id);
        formData.append("status", element.status);

        this.serverService
          .EStatusUpdateForm(url, formData, this.authToken)
          .subscribe(
            (data) => {
              this.clipBoardService.showMessgeInText(
                "Presale Job Status Updated Successfully",
                "success-snackbar"
              );
              this.showComponentLoader = false;
            },
            (err) => {
              this.clipBoardService.checkServerError(err, this.authToken);
              this.showComponentLoader = false;
            }
          );

        // this.allSaleCampaign()
        this.allPreSaleJobMaster();
        //this.timeLine();
      } else {
        this.allPreSaleJobMaster();
        this.showComponentLoader = false;
      }
    });
  }

  openEscalationUpdateModal(project: any) {
    (project["new_status"] = project.status),
      (this.escalationStatusModalComponent = this.dialog.open(
        EscalationStatusModalComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "1020px",
          panelClass: "cdk-overlay-panel-right-side",
          data: project,
        }
      ));
    this.escalationStatusModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  openAscalationCommentModal(project) {
    project["commentType"] = "presales";
    this.presaleCommentModalComponent = this.dialog.open(
      PresaleCommentModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1020px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.presaleCommentModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  sendfeedback(project: any) {
    (project["new_status"] = "feedback"),
      (this.escalationStatusModalComponent = this.dialog.open(
        EscalationStatusModalComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "1020px",
          panelClass: "cdk-overlay-panel-right-side",
          data: project,
        }
      ));
    this.escalationStatusModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.allPreSaleJobMaster();
      }
    });
  }

  assignUserToJobs(campaign: any) {
    if (campaign.status.toUpperCase() != "CANCELLED") {
      campaign["job_table_type"] = "presales";
      this.assignUserToJobsComponent = this.dialog.open(
        AssignUserToJobsComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "500px",
          panelClass: "cdk-overlay-panel-right-side",
          data: campaign,
        }
      );
      this.assignUserToJobsComponent.afterClosed().subscribe((result) => {
        if (result != undefined) {
          this.allPreSaleJobMaster();
        }
      });
    }
  }

  openJobAttachmentModal(project, job_table_type: any) {
    if (project.status.toUpperCase() != "CANCELLED") {
      project["file_type_job"] = job_table_type;
      this.campaignJobAttachmentsComponent = this.dialog.open(
        CampaignJobAttachmentsComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "700px",
          panelClass: "cdk-overlay-panel-right-side",
          data: project,
        }
      );
      this.campaignJobAttachmentsComponent.afterClosed().subscribe((result) => {
        if (
          result != undefined ||
          localStorage.getItem("Attachment_job") == "true"
        ) {
          this.showComponentLoader = true;
          // this.allSaleCampaign()
          this.allPreSaleJobMaster();
          //this.timeLine();
        }
      });
    }
  }

  openJobLinksModal(project, job_table_type: any) {
    project["job_table_type"] = job_table_type;
    this.campaignJobLinksComponent = this.dialog.open(
      CampaignJobLinksComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.campaignJobLinksComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.allPreSaleJobMaster();
        //this.timeLine();
      }
    });
  }
  navToCampaign(item: any) {
    this.router.navigate([]).then((result) => {
      window.open("page/campaign-details/" + item.campaign_id, "_blank");
    });
  }
  presalesLogsListing(element: any) {
    this.listingPresalesProgressLogComponent = this.dialog.open(
      ListingPresalesProgressLogComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "55vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: element,
      }
    );
    this.listingPresalesProgressLogComponent
      .afterClosed()
      .subscribe((result) => {
        if (result != undefined) {
          this.showComponentLoader = true;
          // this.allSaleCampaign()
          this.allPreSaleJobMaster();
        }
      });
  }
  CreatepresalesLog(element: any) {
    this.createPresalesProgressLogComponent = this.dialog.open(
      CreatePresalesProgressLogComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "75vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: element,
      }
    );
    this.createPresalesProgressLogComponent
      .afterClosed()
      .subscribe((result) => {
        if (result != undefined) {
          this.showComponentLoader = true;
          // this.allSaleCampaign()
          this.allPreSaleJobMaster();
        }
      });
  }
}
